import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import MainContent from './components/MainContent';
import Especialidades from './components/Especialidades';
import PorQueElegirnos from './components/PorQueElegirnos';
import ProfesionalesExcelencia from './components/ProfesionalesExcelencia';
import DoctorGonzalo from './components/DoctorGonzalo';
import DoctorMichael from './components/DoctorMichael';
import LideresTecnologicos from './components/LideresTecnologicos';
import Testimonios from './components/Testimonios';
import Implantologia from './components/Implantologia';
import Servicios from './components/Servicios';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
// Importar la fuente
import './index.css';
import WhatsappButton from './components/WhatsappButton';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <MainContent />
              <Especialidades variant="main" />
              <PorQueElegirnos />
              <Testimonios />
              <Implantologia />
            </>
          } />
          <Route path="/profesionales" element={<ProfesionalesExcelencia />} />
          <Route path="/doctor-gonzalo" element={<DoctorGonzalo />} />
          <Route path="/doctor-michael" element={<DoctorMichael />} />
          <Route path="/lideres-tecnologicos" element={<LideresTecnologicos />} />
          <Route path="/servicios" element={<Servicios />} />
        </Routes>
        <Footer />
        <WhatsappButton telefono="56978712707" texto="¡Hola CAIMA! Quisiera agendar una hora." tooltip="Dudas o agenda tu hora" />
      </div>
    </Router>
  );
}

export default App;
